import React from "react"
import styled from "styled-components"
import { Link, useStaticQuery, graphql } from "gatsby"
import Image from "gatsby-image"

const getImage = graphql`
  query {
    logos: allFile(filter: { relativePath: { in: ["icon.png", "logo.png"] } }) {
      nodes {
        childImageSharp {
          fluid {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
    }
  }
`

const NavbarLogo = () => {
  const data = useStaticQuery(getImage)
  const fluidLogos = data.logos.nodes.map(node => node.childImageSharp.fluid)
  const [icon, logo] = fluidLogos

  return (
    <>
      <Icon>
        <Link to="/">
          <Image fluid={icon} alt="Shopify Systems" />
        </Link>
      </Icon>
      <Logo>
        <Link to="/">
          <Image fluid={logo} alt="Shopify Systems" />
        </Link>
      </Logo>
    </>
  )
}

const Icon = styled.div`
  width: 31px;
  margin: 10px 0 0 0px;
  @media (min-width: 321px) {
    display: none;
  }
  @media (min-width: 568px) and (orientation: landscape) {
    display: block;
  }
  @media (min-width: 411px) and (orientation: portrait) {
    display: none;
  }
  @media (min-width: 768px) {
    display: none;
  }
`
const Logo = styled.div`
  width: 144px;
  margin: 10px 0 0 0px;
  display: none;
  @media (min-width: 321px) {
    display: block;
  }
  @media (min-width: 568px) and (orientation: landscape) {
    display: none;
  }
  @media (min-width: 411px) and (orientation: portrait) {
    display: block;
  }
  @media (min-width: 768px) {
    display: block;
  }
  @media (min-width: 1025px) {
    margin-top: 20px;
    margin-bottom: 24px;
    width: 195px;
  }
`

export default NavbarLogo
